import * as v from 'valibot'

export function getFirstLetter(text: string | undefined | null) {
  if (typeof text === 'string' && text.length > 0) {
    return text.charAt(0).toLowerCase()
  }
  return 'a'
}

export const nonEmptyString = v.pipe(v.string(), v.minLength(1))

/**
 * Replaces variables in a string with their values
 *
 * @param raw - a string potentially containing variables in the form of `{{ variableKey }}`
 * @param variables - an object containing the values to replace the variables with, i.e. `{ variableKey: 'value' }`
 *
 * @returns the string with the variables replaced, or the original string if no variables were found
 */
export function interpolate<T extends string | undefined | null>(raw: T, variables: Record<string, string | number> | undefined): T {
  if (!raw || !variables) {
    return raw
  }

  // @ts-expect-error I don't think this is possible to type correctly
  return raw.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, key) => {
    return key in variables ? variables[key] : `{{${key}}}`
  }) as T
}
